import styled from "styled-components";
import { borderRadius, mediaQueries, spacing, typographyMixin } from "@magicbi/ui-library";
import { Modal } from "../../../design-system/components/composite/Modal/Modal";

/** The workspace size (880px) unless a `width` is passed to Modal. Full screen on phones. */
export const Shell = styled(Modal)`
  border-radius: ${borderRadius[14]};
  ${mediaQueries.down.sm} {
    width: 100%;
    max-width: none;
    height: 100%;
    max-height: none;
    border-radius: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${spacing[3]};
  padding: ${spacing[4]} ${spacing[5]} ${spacing[3]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.stroke};
`;

export const HeaderText = styled.div`
  display: grid;
  gap: ${spacing[1]};
  min-width: 0;
`;

export const Kicker = styled.span`
  ${typographyMixin("overline", 4)}
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Title = styled.h2`
  margin: 0;
  ${typographyMixin("heading", "h4")}
  color: ${({ theme }) => theme.colors.text.primary};

  &:focus {
    outline: none;
  }
`;

export const Description = styled.p`
  margin: 0;
  max-width: 72ch;
  ${typographyMixin("body", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  display: grid;
  align-content: start;
  gap: ${spacing[6]};
  padding: ${spacing[4]} ${spacing[5]} ${spacing[5]};
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing[2]};
  padding: ${spacing[3]} ${spacing[5]};
  border-top: 1px solid ${({ theme }) => theme.colors.border.stroke};
`;

export const Status = styled.div`
  flex: 1;
  min-width: 12.5rem;
  ${typographyMixin("body", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};

  b,
  strong {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;

export const StatusError = styled.div`
  ${typographyMixin("caption", 2)}
  color: ${({ theme }) => theme.colors.error.text};
`;
